import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import ChatApp from "../components/Contents/ChatApp";

/**
 * 대화방만 단독 브라우저 창으로 사용하는 전용 페이지.
 * URL 쿼리: panel (brd|chat|support), ondsid, chatname (선택) → 선택한 패널만 표시
 */
const VALID_PANELS = ["brd", "chat", "support"];

export default function StandaloneChatPage(props) {
  const location = useLocation();
  const params = new URLSearchParams(location.search || "");
  const panelParam = params.get("panel") || "chat";
  const visiblePanels = panelParam.split(",").filter((p) => VALID_PANELS.includes(p.trim()));
  const panels = visiblePanels.length ? visiblePanels : ["chat"];
  const chatnameFromUrl = params.get("chatname");
  const initialChatname = chatnameFromUrl ? decodeURIComponent(chatnameFromUrl) : (typeof sessionStorage !== "undefined" ? sessionStorage.chatname || "" : "");

  useEffect(() => {
    const q = new URLSearchParams(location.search || "");
    const ondsid = q.get("ondsid");
    const chatname = q.get("chatname");
    if (ondsid != null && ondsid !== "") {
      try {
        sessionStorage.ondsid = ondsid;
      } catch (e) {
        console.warn("StandaloneChat: sessionStorage.ondsid set failed", e);
      }
    }
    if (chatname != null && chatname !== "") {
      try {
        sessionStorage.chatname = decodeURIComponent(chatname);
      } catch (e) {
        console.warn("StandaloneChat: sessionStorage.chatname set failed", e);
      }
    }
  }, [location.search]);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        bgcolor: "#f5f5dc",
        boxSizing: "border-box",
      }}
    >
      <Box sx={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <ChatApp
          apiAddr={props.apiAddr}
          refreshBrd={() => {}}
          refreshChat={() => {}}
          fullswitch={true}
          visiblePanels={panels}
          fullHeight
          chatname={initialChatname}
        />
      </Box>
    </Box>
  );
}
